import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import AllProductEach from "./AllProductEach";
import ShoeMenu from "./Product/Menu/ShoeMenu";
import PageTop from "../PageTop";
import Fade from "react-reveal/Fade";
import { useProductContext } from "../../context/ProductContext";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  stretch: { display: "flex", alignItems: "stretch" },
  item: {
    cursor: "pointer",
    border: "1px solid #dee5ec",
    borderRadius: "20px",
    textAlign: "center",
    "&:hover": {
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    },
  },
  product__content: {
    marginBottom: "70px",
  },
  product__img: {
    maxWidth: "500px",
    minWidth: "200px",
    borderRadius: "2%",
    cursor: "pointer",
  },
  productMenu: { lineHeight: "2.3em" },
  font13: { fontSize: "11px", color: "#757575" },
});

const AllProducts = () => {
  const classes = useStyles();
  const { products } = useProductContext();
  const { t, i18n } = useTranslation();

  return (
    <>
      <Fade delay={400}>
        <PageTop
          title={t("Care with Nano Technology")}
          smallTitle={t(
            "HESLET BIO products quickly and strongly adsorbs and neutralizes various fine particles that pollute the room"
          )}
          img="img/living.jpeg"
        />
      </Fade>
      <Fade delay={500}>
        <Grid
          container
          sx={{
            minWidth: { md: 1000, xs: 200 },
            px: 6,
          }}
        >
          <ShoeMenu />
          <Grid
            item
            md={9}
            sm={12}
            sx={{
              pb: 2,
              display: { xs: "flex" },
              flexDirection: { xs: "column" },
              justifyContent: { xs: "center" },
            }}
          >
            <section id="bio"></section>
            <Box
              className="menu_title"
              sx={{
                pb: 1,
                pt: 6,
                textAlign: "left",
              }}
            >
              {t("Helset Shoe Care Products")}
            </Box>
            <Box
              sx={{
                textAlign: "left",
                pt: 1,
                color: "#2e2d2b",
                pb: 3,
                fontSize: "13px",
                lineHeight: "170%",
              }}
              className="normal"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: t("Non-toxic & Chemical-Free"),
                }}
              />
            </Box>

            <Grid container sx={{ width: 1, pt: 2, pb: 10 }} spacing={4}>
              {products.map((product) => {
                if (product.group === "living") {
                  return (
                    <Grid
                      item
                      md={6}
                      sx={{
                        boxSizing: "border-box",
                      }}
                    >
                      <AllProductEach
                        linkTo={product.linkTo}
                        title={t(product.title)}
                        subtitle={t(product.subtitle)}
                        imgs={product.imgs}
                        img={product.img}
                      />
                    </Grid>
                  );
                }
              })}
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </>
  );
};

export default AllProducts;
